import React, { useState } from "react";
import NavigationControl from "components/Photos/PhotoTool/SinglePhoto/NavigationControls.tsx";
import ReactCrop, { type Crop } from "react-image-crop";
import "react-image-crop/src/ReactCrop.scss";

interface SinglePhotoProps {
  photoCount: number,
  onPhotoIndexChange: (i: number) => void,
  selectedPhotoIndex: number,
  isEditingPhoto: boolean,
  imgSource: string,
  isCropping: boolean,
  setCrop: (c: Crop) => void,
  photoWidth?: number,
  photoHeight?: number,
  editedPhotoIds: string[],
  photoId: string,
}

const cropDefault: Crop = {
  unit: '%',
  x: 25,
  y: 25,
  width: 25,
  height: 25,
};

const SinglePhoto = (props: SinglePhotoProps) => {

  if (!props.imgSource) return (<></>);

  const [crop, setCrop] = useState<Crop>(cropDefault);

  const onCropChange = (newCrop: Crop) => {
    props.setCrop(newCrop);
    setCrop(newCrop);
  };

  return (
    <div className={props.isEditingPhoto ? "single-photo single-photo-edit-mode" : "single-photo"}>
      {props.isCropping ?
        <ReactCrop
          crop={crop}
          onChange={onCropChange}
          className="single-photo-cropping-tool"
          minWidth={200}
          minHeight={200}
        >
          <img src={`${props.imgSource}${props.editedPhotoIds?.includes(props.photoId) ? `&t=${new Date().valueOf().toString()}` : ''}`} /> {/* Adding a date string to the query to force re-fetching the image, otherwise it doesn't refresh after an edit*/}
        </ReactCrop>
        :
        <img src={`${props.imgSource}${props.editedPhotoIds?.includes(props.photoId) ? `&t=${new Date().valueOf().toString()}` : ''}`} width={props.photoWidth} height={props.photoHeight} />
      }

      <NavigationControl
        photoCount={props.photoCount}
        selectedPhotoIndex={props.selectedPhotoIndex}
        onPhotoIndexChange={props.onPhotoIndexChange}
        isEditingPhoto={props.isEditingPhoto}
      />
    </div>
  );
};

export default SinglePhoto;
